// extracted by mini-css-extract-plugin
module.exports = {"titleInformation":"detail_titleInformation__Y5uO0","tableRow":"detail_tableRow__G4At_","gallery":"detail_gallery__NC1Mw"};